import Styled from 'styled-components';

export const SectionWrapper = Styled.div`
  margin-top: 2em;
`;
